import { useCallback } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { qcReviewService } from "../services/qcReview.service";

export function useQcFailureNotices(enabled: boolean) {
  const client = useQueryClient();
  const query = useQuery({
    queryKey: ["qc-failure-notices"],
    queryFn: qcReviewService.notices,
    enabled,
    refetchInterval: 5000,
  });
  const markRead = useCallback(
    async (id: string) => {
      await qcReviewService.markRead(id);
      await client.invalidateQueries({ queryKey: ["qc-failure-notices"] });
    },
    [client]
  );
  return {
    notices: query.data?.data || [],
    unreadCount: query.data?.unreadCount || 0,
    markRead,
  };
}
